import React from 'react'

const SigninPage = () => {
  return (
    <div>
        <h1>Formulario de Contacto</h1>
    </div>
  )
}

export default SigninPage